define('SageDotCom/Utility/sanitizer',[], function () {
    function Sanitizer() {

        this.stripHtml = function (str) {
            if (typeof str !== "string") {
                return "";
            }
            if (str) {
                var stripHtmlRegularExpression = /<[^>]+>/gm;
                return str.replace(new RegExp(stripHtmlRegularExpression), "");
            }
            return "";
        };

        // for use when the return should include html like promotemplate from commerce api calls
        this.sanitizeHtml = function (str) {
            if (typeof str !== "string") {
                return "";
			}

			let parser = new DOMParser();
			let doc = parser.parseFromString(str, 'text/html');
			var html = doc.body;

			//first remove any script tags
			var scripts = html.querySelectorAll('script');
			for (let script of scripts) {
				script.remove();
			}

			clean(html);
			function clean(html) {
				let nodes = html.children;
				for (let node of nodes) {
					removeAttributes(node);
					clean(node);
				}
			}

			function removeAttributes(elem) {
				let atts = elem.attributes;
				for (let { name, value } of atts) {
					if (!isPossiblyDangerous(name, value)) continue;
					elem.removeAttribute(name);
				}
			}

			function isPossiblyDangerous(name, value) {
				let val = value.replace(/\s+/g, '').toLowerCase();
				if (['src', 'href', 'xlink:href'].includes(name)) {
					if (val.includes('javascript:') || val.includes('data:text/html')) return true;
				}
				if (name.startsWith('on')) return true;
			}
			return html.innerHTML;
        };

		this.containsHTML = function (input) {
            const doc = new DOMParser().parseFromString(input, "text/html");
            return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
        }
    }

    return new Sanitizer();
});
